import { render, staticRenderFns } from "./Blend.vue?vue&type=template&id=356768fa"
import script from "./Blend.vue?vue&type=script&lang=js"
export * from "./Blend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports